export default "__VITE_PUBLIC_ASSET__3bb2d9dc__"